export const MAX_BANNED_WORD_LENGTH = 50;

const WORD_PREVIEW_LENGTH = 30;

export function parseBannedWordsCsv(text: string): string[] {
  return Array.from(
    new Set(
      text
        .split(/[\r\n,;]+/)
        .map((word) => word.trim())
        .filter(Boolean),
    ),
  );
}

export function findTooLongBannedWords(words: string[]): string[] {
  return words.filter((word) => word.trim().length > MAX_BANNED_WORD_LENGTH);
}

export function previewBannedWord(word: string): string {
  return word.length > WORD_PREVIEW_LENGTH ? `${word.slice(0, WORD_PREVIEW_LENGTH)}…` : word;
}
